/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query'
import type {
	UseQueryOptions,
	UseQueryResult,
	UseSuspenseQueryOptions,
	UseSuspenseQueryResult,
} from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { organisationIndex } from '../../axios/organisationIndex'
import type {
	OrganisationIndexError,
	OrganisationIndexQueryParams,
	OrganisationIndexResponse,
} from '../../types/OrganisationIndex'

export const organisationIndexQueryKey = (params?: OrganisationIndexQueryParams) =>
	[{ url: '/organisations' }, ...(params ? [params] : [])] as const

export type OrganisationIndexQueryKey = ReturnType<typeof organisationIndexQueryKey>

/** @see backend/nexus/modules/Organisation/Http/Controllers/OrganisationController.php OrganisationController::index */
export function organisationIndexQueryOptions(params?: OrganisationIndexQueryParams, config?: AxiosRequestConfig) {
	return queryOptions<
		OrganisationIndexResponse,
		AxiosError<OrganisationIndexError>,
		OrganisationIndexResponse,
		OrganisationIndexQueryKey
	>({
		queryKey: organisationIndexQueryKey(params),
		queryFn: ({ signal }) => organisationIndex(params, { signal, ...config }).then(res => res.data),
	})
}

/** @see backend/nexus/modules/Organisation/Http/Controllers/OrganisationController.php OrganisationController::index */
export function useOrganisationIndex<TSelectData = OrganisationIndexResponse>(
	params?: OrganisationIndexQueryParams,
	options?:
		& Partial<
			Omit<
				UseQueryOptions<
					OrganisationIndexResponse,
					AxiosError<OrganisationIndexError>,
					TSelectData,
					OrganisationIndexQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseQueryResult<TSelectData, AxiosError<OrganisationIndexError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useQuery({
		...organisationIndexQueryOptions(params),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}

/** @see backend/nexus/modules/Organisation/Http/Controllers/OrganisationController.php OrganisationController::index */
export function useOrganisationIndexSuspense<TSelectData = OrganisationIndexResponse>(
	params?: OrganisationIndexQueryParams,
	options?:
		& Partial<
			Omit<
				UseSuspenseQueryOptions<
					OrganisationIndexResponse,
					AxiosError<OrganisationIndexError>,
					TSelectData,
					OrganisationIndexQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseSuspenseQueryResult<TSelectData, AxiosError<OrganisationIndexError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useSuspenseQuery({
		...organisationIndexQueryOptions(params),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}
